




























import { Vue, Component, Prop } from 'vue-property-decorator';
import { AdContentBlockViewModel, LineItemViewObject } from '@/types/apiServerContract';
import adnuntiusService from '@/project/personalization/adnuntius.service';
import Api from '@/project/http/Api.service';
import { uniqBy } from 'lodash';
import serverContext from '@/core/serverContext.service';
import contentApiService from '@/core/http/contentApi.service';
import { BasketPageViewModel, TabbedContentViewModel } from '@/types/contentServerContract';
import { AdnuntiusTrackingData } from '@/project/tracking/adnuntius/types';
import AdnuntiusPixels from '@/project/tracking/adnuntius/AdnuntiusPixels.vue';
import ImageTextVideoBlock from './ImageTextVideoBlock.vue';
import Tabs from '@/core/ui-components/tabs/Tabs.vue';
import Tab from '@/core/ui-components/tabs/Tab.vue';

@Component({
    components: { AdnuntiusPixels, ImageTextVideoBlock, Tabs, Tab }
})
export default class AdnuntiusBasketBannerBlock extends Vue {
    @Prop({ type: Array, required: true })
    lineItems!: LineItemViewObject[];

    adContentBlockViewModel: AdContentBlockViewModel | null = null;
    adnuntiusTrackingData: AdnuntiusTrackingData | null = null;
    tabs: TabbedContentViewModel[] = [];
    contentLoadError = false;
    loaded = false;

    get canRender() {
        return this.loaded && (this.tabs.length > 0 || !!this.adContentBlockViewModel);
    }

    created() {
        this.init();
    }

    async init() {
        await Promise.all([this.getAdContent(), this.getPageData()]).finally(() => this.loaded = true);
    }

    async getAdContent() {
        try {
            this.adContentBlockViewModel = await Api.personalization.basketPageBanner({
                contactKey: adnuntiusService.getContactKey(),
                customerKey: adnuntiusService.getCustomerKey(),
                currentUrl: this.$route.fullPath,
                itemIds: this.lineItems.map(x => x.itemId),
                brands: uniqBy(this.lineItems.filter(x => !!x.brand).map(x => x.brand as string), x => x),
                categoryIds: uniqBy(this.lineItems.filter(x => !!x.categoryId).map(x => x.categoryId as string), x => x)
            });

            if (this.adContentBlockViewModel.lineItemId && this.adContentBlockViewModel.creativeId) {
                this.adnuntiusTrackingData = {
                    lineItemId: this.adContentBlockViewModel.lineItemId,
                    creativeId: this.adContentBlockViewModel.creativeId,
                    parentBlockAlias: 'basketBannerBlock'
                };
            }
        } catch {
            this.contentLoadError = true;
        }
    }

    async getPageData() {
        if (!serverContext?.settings?.basketPage) return;

        const pageUrl = `${serverContext.settings.basketPage}`;
        try {
            const result = await contentApiService.getContent<BasketPageViewModel>(pageUrl);
            this.tabs = result.blocks.map(x => x.content as TabbedContentViewModel);
        } catch {
            // No content - ignored
        }
    }

    get renderedPixelUrl() {
        return this.adContentBlockViewModel?.renderedPixelUrl;
    }

    get viewPixelUrl() {
        return this.adContentBlockViewModel?.viewPixelUrl;
    }

    get visiblePixelUrl() {
        return this.adContentBlockViewModel?.visiblePixelUrl;
    }

    get clickPixelUrl() {
        return this.adContentBlockViewModel?.clickPixelUrl;
    }
}
